






















import { Component, Vue } from 'vue-property-decorator';
import {
  NotificationChannelDto,
  NotificationPreferenceDto,
  UserNotificationsApi
} from '@eurogast/hub-client-typescript';
import { ApiService } from '@/services/ApiService';

@Component({})
export default class NotificationPreferences extends Vue {
  public preferences: NotificationPreferenceDto[] = [];
  private api = ApiService.wrap(UserNotificationsApi);

  public mounted() {
    this.api.getUserNotificationPreferences().then((result) => {
      this.preferences = result.filter((it) => !!it.notificationType);
    }).catch(ApiService.defaultErrorHandler);
  }

  get channels(): NotificationChannelDto[] {
    // currently no other channels are supported ('WEBSHOP' is default and therefore not listed)
    return [NotificationChannelDto.EMAIL];
  }

  public togglePreference(notificationType, channel) {
    const typeIndex = this.preferences
      .find((pref) => pref.notificationType === notificationType);
    if (typeIndex) {
      const channelIndex = typeIndex.notificationChannels.indexOf(channel);
      if (channelIndex === -1) {
        typeIndex.notificationChannels.push(channel);
      } else {
        typeIndex.notificationChannels.splice(channelIndex, 1);
      }
    } else {
      this.preferences.push({ notificationType, notificationChannels: [channel] });
    }
  }

  public updateUserNotificationPreferences() {
    this.api.updateUserNotificationPreferences(this.preferences)
      .then(() => window.location.href = '/my/user-profile')
      .catch(ApiService.defaultErrorHandler);
  }
}
